import { render } from "./RegistrationComponent.vue?vue&type=template&id=19ae01f6&scoped=true"
import script from "./RegistrationComponent.vue?vue&type=script&lang=js"
export * from "./RegistrationComponent.vue?vue&type=script&lang=js"

import "./RegistrationComponent.vue?vue&type=style&index=0&id=19ae01f6&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ae01f6"]])

export default __exports__